<template>
  <div class="full_layout">
    <menu-title :title="title" />
    <div class="sub-div">
      <div
        v-if="routes.length>1"
        class=" top_router_bar"
        style="background: linear-gradient(to right, #031e36, #063866)"
      >
        <div class="top_router_bar_item">
          <div v-for="(item, i) in routes" :key="i">
            <router-link :to="item.path">
              <div class="box">{{ item.meta.title }}</div>
            </router-link>
          </div>
        </div>
        <div class="bar" />
      </div>

      <div class="flex-1 full_layout_container">
        <transition class="flex-1" name="fade-transform" mode="out-in">
          <router-view :key="key" class="flex-1" />
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import MenuTitle from '@/components/menuTitle.vue'
export default {
  name: 'FullLayout',
  components: {
    MenuTitle
  },
  data() {
    return {}
  },
  computed: {
    key() {
      return this.$route.path
    },
    // 获取当前路由的子路由
    routes() {
      var routes = {
        children: this.$router.options.routes
      }
      var route = this.$route.matched
      for (var i = 0; i < route.length - 1; i++) {
        routes = routes.children.find((e) => e.name === route[i].name)
      }
      return routes.children
    },
    title: function() {
      var title = ''
      var roterLength = this.$route.matched.length
      if (roterLength) {
        title = this.$route.matched[roterLength - 2].meta.title
      } else {
        title = ''
      }
      return title
    }
  }
}
</script>
<style lang="scss" scoped>
.full_layout_container{
    height: calc(100% - vh(45));
    //overflow-y: auto;
    //flex: 1;
    //display: flex;
    //flex-direction: column;
    //flex-shrink: 0;
    // height: 100%;
     // width: 100%;
}
.top_router_bar {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  // overflow: auto;
  flex-direction: column;
}
.top_router_bar_item{
  display: flex;
  justify-content: flex-start;
}
.sub-div {
  height: calc(100% - 45px);
  display: flex;
  flex-direction: column;
  flex: 1;

}

.full_layout {
  .bar {
    width: 100%;
    height: 6px;
    background: #0076ff;
  }
  .box {
    cursor: pointer;
    margin-right: 3px;
    min-width: 110px;
    height: 0;
    border-width: 0px 15px 35px 0px;
    border-style: none solid solid;
    border-color: transparent transparent  #253343;
    font-size: 15px;
    line-height: 38px;
    padding: 0 10px;
    text-align: center;
  }
  .router-link-active {
    .box {
      border-color: transparent transparent #0076ff;
    }
  }
}
</style>
